module.exports = __webpack_public_path__ + "img/resources.7648add5.png";